const { getItem, removeItem, setItem } = require('../helpers/local-storage.js');

module.exports = class LocalStore {
	constructor(authKey) {
		this._authKey = authKey;
	}

	get() {
		return getItem(this._authKey);
	}

	set(auth) {
		if (auth === null) {
			removeItem(this._authKey);

			return;
		}

		setItem(this._authKey, auth);
	}
};
